const collectionsSelectors = {

};

class templateCollectionsJS {
    constructor() {
      var dataAll = document.querySelectorAll('[data-add-cart-collection]');
      dataAll.forEach(function (target) {
        target.addEventListener('click', function(event) {
          event.preventDefault();
          if (event.currentTarget.closest('[data-closest]').querySelector('.tooltip-content').classList.contains('d-none')) {
            document.querySelectorAll('.tooltip-content').forEach(function (target) {
              target.classList.add('d-none');
            });
            event.currentTarget.closest('[data-closest]').querySelector('.tooltip-content').classList.remove('d-none');
          } else {
            document.querySelectorAll('.tooltip-content').forEach(function (target) {
              target.classList.add('d-none');
            });
          }
        });
      });
      this.nextFunction();
      this.backFunction();
    }

    nextFunction() {
      const that = this;
      var nextClick = document.querySelectorAll('[data-next-click]');
      nextClick.forEach(function (target) {
        target.addEventListener('click', function(event) {
          event.preventDefault();
          var htmlContent = event.currentTarget.closest('[data-list-closest]').querySelector('[data-mobile-show]').innerHTML;
          document.querySelector('[data-show-product]').innerHTML = htmlContent;
          document.querySelector('[data-show-product]').classList.remove('d-none');
          document.querySelector('.collection-list-wrapper').classList.add('d-none');
          that.backFunction();
        });
      });
    }
  
    backFunction() {
      const that = this;
      var backClick = document.querySelectorAll('[data-back-click]');
      backClick.forEach(function (target) {
        target.addEventListener('click', function(event) {
          event.preventDefault();
          document.querySelector('[data-show-product]').innerHTML = '';
          document.querySelector('[data-show-product]').classList.add('d-none');
          document.querySelector('.collection-list-wrapper').classList.remove('d-none');
          that.nextFunction();
        });
      });
    }
}

typeof templateCollectionsJS !== 'undefined' && new templateCollectionsJS();